'use client';

import { useEffect, useRef } from 'react';

const stats = [
  { value: '14,200+', label: 'Students diagnosed' },
  { value: '73%', label: 'Score improvement in 3 weeks' },
  { value: '1,247', label: 'Practice questions' },
  { value: '4.9 / 5', label: 'Average student rating' },
  { value: '92%', label: 'Pass rate, nursing students' },
];

export default function TrustBar() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.2 }
    );
    ref?.current?.querySelectorAll('.reveal')?.forEach(el => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 px-6 md:px-12 bg-green">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-4">
          {stats?.map((stat, i) => (
            <div
              key={stat?.label}
              className={`reveal reveal-delay-${i + 1} text-center`}
            >
              <p className="font-fraunces text-3xl md:text-4xl font-light text-cream mb-1">
                {stat?.value}
              </p>
              <p className="text-xs font-medium text-green-pale/70 uppercase tracking-wide">
                {stat?.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}